module.exports = __webpack_public_path__ + "static/img/dialog-img.64ebf062.png";